// removed by extract-text-webpack-plugin
module.exports = {"cover":"_1hnpb","overlay":"_2h1FT","content":"_1CXwb"};


//////////////////
// WEBPACK FOOTER
// ./app/components/page-cover/page-cover.scss
// module id = 1434
// module chunks = 0